<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Text, Token } from '@Shelly/shelly-design-system';
	import { _deepClone, capFirstChar, conditionsFunc } from '../../../../../../../../helpers/utilities';
	import { is_time_based_cond } from '../../../../../../../../types/TimeBasedConditionsUI';
	import { _init_time_based_conditions } from '../../../../../../helpers/init_time_conditions';
	import TimerTrigger from './Components/TimerTriggerV2.svelte';
	import DailyTrigger from './Components/DailyTriggerV2.svelte';
	import OneTimeTrigger from './Components/OneTimeTriggerV2.svelte';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { WHEN_WIZARD_STEPS_INDEXES } from '../../helpers/when-wizard-helpers';

	import type { SelectOptionPropsType } from '@Shelly/shelly-design-system';
	import type { TimeBasedConditionsUI } from '../../../../../../../../types/TimeBasedConditionsUI';

	export let sceneData: any;

	let selectedType: SelectOptionPropsType = {
		title: 'Select time based option',
		value: undefined,
	};

	const time_bassed_options: SelectOptionPropsType[] = _init_time_based_conditions.map((el) => {
		return {
			title: $format(el.title),
			value: el.props._gui_type,
		};
	});

	if (is_time_based_cond(sceneData.translated)) {
		sceneData._time_trigger_obj = _deepClone(sceneData.translated) as TimeBasedConditionsUI;
		selectedType = {
			title: $format(_init_time_based_conditions[sceneData._time_trigger_obj.id].title),
			value: sceneData._time_trigger_obj._gui_type,
		};
	}

	const validateWizardTimeProp = () => {
		sceneData.validStepIndex = WHEN_WIZARD_STEPS_INDEXES.TIME_BASED_STEP;
		sceneData.isValid = false;
	};

	const validateWizardTimeCondition = () => {
		// if (
		// 	sceneData.validStepIndex !== WHEN_WIZARD_STEPS_INDEXES.TIME_BASED_STEP
		// ) {
		// 	return;
		// }
		sceneData.isValid =
			sceneData._time_trigger_obj._gui_type === 'timer'
				? !conditionsFunc(sceneData._time_trigger_obj.value, true)
				: (sceneData._time_trigger_obj?.value?.time?.length === 5 &&
						sceneData._time_trigger_obj?.value?.isin?.length > 0) ||
					(sceneData._time_trigger_obj?.value?.time?.length === 5 &&
						sceneData._time_trigger_obj?.value?.date?.length > 0);
	};

	const change_selected = (e) => {
		validateWizardTimeProp();

		selectedType = { ...e.detail };
		sceneData._time_trigger_obj._gui_type = selectedType.value;
		sceneData._time_trigger_obj.id = _init_time_based_conditions.findIndex(
			(el) => el.props._gui_type === selectedType.value,
		);
		if (selectedType.value === 'timer') sceneData._time_trigger_obj.value = 1;

		if (selectedType.value === 'ot_cond') {
			sceneData._time_trigger_obj.value = {
				time: '00:00',
				date: new Date().toISOString().split('T')[0],
			};
		}
		if (selectedType.value === 'd_cond') {
			sceneData._time_trigger_obj.value = {
				time: '00:00',
				isin: [],
			};
		}
	};

	$: (sceneData, validateWizardTimeCondition());
</script>

<Text element="h2" class="mb-s">
	{$format('label_time_prop', {
		default: 'Select time based properties',
	})}
</Text>

<div
	class={classMap({ 'd-flex flex-wrap': true, 'mb-l': selectedType.value })}
	style="gap:var(--spacing-s)"
>
	{#each time_bassed_options as option}
		<Token
			id="token-3ts54so"
			title={capFirstChar(option.title)}
			class="text-capitalize"
			on:click={() => change_selected({ detail: option })}
			selected={selectedType.value === option.value}
		/>
	{/each}
</div>

{#if selectedType.value === 'timer'}
	<TimerTrigger bind:input_val={sceneData._time_trigger_obj.value} />
{:else if selectedType.value === 'd_cond'}
	<DailyTrigger bind:value={sceneData._time_trigger_obj.value} />
{:else if selectedType.value === 'ot_cond'}
	<OneTimeTrigger bind:value={sceneData._time_trigger_obj.value} />
{/if}
